var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4653 4.2248V16.7998C18.4653 17.1998 18.3153 17.5498 18.0153 17.8498C17.7153 18.1498 17.3653 18.2998 16.9653 18.2998H1.96533C1.56533 18.2998 1.21533 18.1498 0.915332 17.8498C0.615332 17.5498 0.465332 17.1998 0.465332 16.7998V1.7998C0.465332 1.3998 0.615332 1.0498 0.915332 0.749805C1.21533 0.449805 1.56533 0.299805 1.96533 0.299805H14.5403L18.4653 4.2248ZM16.9653 4.8998L13.8653 1.7998H1.96533V16.7998H16.9653V4.8998ZM9.45946 15.1748C10.18 15.1748 10.7945 14.9226 11.3028 14.4182C11.8112 13.9138 12.0653 13.3013 12.0653 12.5807C12.0653 11.8601 11.8131 11.2456 11.3087 10.7373C10.8043 10.229 10.1918 9.9748 9.47121 9.9748C8.75062 9.9748 8.13617 10.227 7.62783 10.7314C7.1195 11.2358 6.86533 11.8483 6.86533 12.5689C6.86533 13.2895 7.11754 13.904 7.62196 14.4123C8.12636 14.9206 8.73886 15.1748 9.45946 15.1748ZM3.29033 6.6998H12.2403V3.1248H3.29033V6.6998ZM1.96533 4.8998V16.7998V1.7998V4.8998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon-save.84dd6baecad760caf81f05f0922d5c42.svg";
export { ForwardRef as ReactComponent };